export default "/images/logosg.png?ce37afa305e193559aaeb35137730b6b";